import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

export interface GeneratedExcessItem {
  installmentNumber: number;
  receiptId: number;
  excessPaymentId: number;
  amount: number;
}

@Component({
  selector: 'app-excess-summary-modal',
  templateUrl: './excess-summary-modal.component.html',
  styles: [`
    @keyframes excess-modal-in {
      from { opacity: 0; transform: scale(.96); }
      to { opacity: 1; transform: scale(1); }
    }
    .excess-modal-panel { animation: excess-modal-in 200ms ease-out; }
    @media (prefers-reduced-motion: reduce) {
      .excess-modal-panel { animation: none; }
    }
  `]
})
export class ExcessSummaryModalComponent implements AfterViewInit {
  @Input() items: GeneratedExcessItem[] = [];
  @Output() closed = new EventEmitter<void>();

  @ViewChild('closeButton') closeButton?: ElementRef<HTMLButtonElement>;

  get total(): number {
    return (this.items ?? []).reduce((acc, i) => acc + Number(i.amount || 0), 0);
  }

  ngAfterViewInit(): void {
    this.closeButton?.nativeElement.focus();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closed.emit();
  }

  close(): void {
    this.closed.emit();
  }
}
